import Vue from 'vue';
import GAuth from 'vue-google-oauth2';

const gauthOption = {
  clientId: '1058884318936-0ph9j5tqfkn559c39qtkgeh4fe571ejn.apps.googleusercontent.com',
  scope: 'profile email'
}

Vue.use(GAuth, gauthOption)